/* eslint-disable complexity */
import {getMarkerUuid} from '../../utils/markers';
import {APP_NAMES, MARKER_TYPES} from '../../constants';
import {
    landingAppDestination,
    pointMarker,
    markerIconStandard,
    landingAppPrice,
    markerIconStandardSelected,
    selectedPointMarker,
    landingAppPointMarker,
    selectedLandingAppPointMarker,
    externalHoveredStandardMarkerIcon,
} from '../../utils/EGMapsMarkerConfig';

const getMarkerByAppAndType = (appName, marker) => {
    if (Object.values(MARKER_TYPES).indexOf(marker.type) > -1) {
        marker.initialType = marker.type;
    }
    marker.initialStatus = marker.status;
    switch (appName) {
        case APP_NAMES.LANDINGAPP:
            switch (marker.initialType) {
                case MARKER_TYPES.PRICE:
                    marker.type = 'property';
                    marker.status = 'available';
                    marker.text = marker.textLabel;
                    marker.qualifiers = [landingAppPrice];
                    return marker;
                case MARKER_TYPES.POI:
                    marker.type = 'place';
                    marker.status = 'available';
                    marker.qualifiers = [
                        marker.isSelected
                            ? selectedLandingAppPointMarker
                            : landingAppPointMarker,
                    ];
                    return marker;
                case MARKER_TYPES.DESTINATION:
                    marker.type = 'property';
                    marker.status = 'available';
                    marker.qualifiers = [landingAppDestination];
                    return marker;
                default:
                    marker.type = 'property';
                    marker.status = 'available';
                    marker.qualifiers = [markerIconStandard];
                    return marker;
            }
        case APP_NAMES.TRIPBOARDS:
            switch (marker.initialType) {
                case MARKER_TYPES.PRICE:
                    const uuid = getMarkerUuid(marker);
                    marker.type = 'property';
                    marker.status = 'available';
                    marker.qualifiers = [`${uuid}`];
                    return marker;
                default:
                    marker.type = 'property';
                    marker.status = 'available';
                    marker.qualifiers = [];
                    return marker;
            }
        case APP_NAMES.SERP:
            marker.type = 'property';
            marker.status = 'available';
            let qualifier = markerIconStandard;
            if (marker.isVisited) {
                qualifier = markerIconStandardSelected;
            }
            if (marker.isHighlighted) {
                qualifier = externalHoveredStandardMarkerIcon;
            }
            marker.qualifiers = [qualifier];
            return marker;
        case APP_NAMES.PDP:
            if (marker.source) {
                marker.type = 'place';
                marker.status = 'available';
                marker.qualifiers = [
                    marker.isSelected ? selectedPointMarker : pointMarker,
                ];
                return marker;
            }
            break;
        default:
            marker.type = 'property';
            marker.status = 'available';
            marker.qualifiers = [markerIconStandard];
            return marker;
    }
    return marker;
};

const getMarkerLabel = (appName, marker) => {
    switch (appName) {
        case APP_NAMES.LANDINGAPP:
            switch (marker.type) {
                case MARKER_TYPES.PRICE:
                    return marker.content;
                case MARKER_TYPES.POI:
                    return marker.label;
                default:
                    return marker.label;
            }
        case APP_NAMES.SERP:
            switch (marker.type) {
                case MARKER_TYPES.PRICE:
                    return marker.text;
                default:
                    return marker.label;
            }
        case APP_NAMES.PDP:
            if (marker.source) {
                return marker.rank >= 0 && `${marker.rank + 1}`;
            }
            break;
        default:
            return marker.textLabel;
    }
    return marker.textLabel;
};

export const updateMarkers = (
    markers,
    appName,
    hoverMarker,
    selectedMarker
) => {
    if (markers) {
        return markers.map((marker) => {
            const uuid = getMarkerUuid(marker);
            marker.isHighlighted = hoverMarker === uuid;
            marker.hoveredMarker = hoverMarker;
            marker.isSelected = selectedMarker === uuid;
            getMarkerByAppAndType(appName, marker);
            let infoWindowOptions;
            switch (appName) {
                case APP_NAMES.SERP:
                    infoWindowOptions = marker.infoWindowOptions;
                    break;
                case APP_NAMES.PDP:
                    infoWindowOptions = {
                        name: marker.name,
                        distance: marker.distance,
                    };
                    break;
                case APP_NAMES.LANDINGAPP:
                    if (marker.type === 'place') {
                        infoWindowOptions = marker.infoWindowOptions;
                    }
                    break;
                default:
                    infoWindowOptions = {};
                    break;
            }
            return {
                lat: marker.position.lat,
                lng: marker.position.lng,
                type: marker.type || null,
                id: uuid,
                name: getMarkerLabel(appName, marker), // this will be shown as the label next to the marker icon if config show is on
                text: marker.content ? marker.content : marker.label,
                status: marker.status,
                qualifiers: marker.qualifiers,
                infoWindowOptions,
                initialStatus: marker.initialStatus,
                initialType: marker.initialType,
            };
        });
    }
    return [];
};

export const getInfoWindowOptions = (markers) => {
    const overlayArrMap = new Map();
    markers.map((marker) => {
        if (marker.infoWindowOptions) {
            overlayArrMap.set(marker.id, marker.infoWindowOptions);
        }
        return overlayArrMap;
    });
    return overlayArrMap;
};
